import Instructor, { InstructorClient } from './instructor.ts'

export { type InstructorClient }
export * from './types'

export default Instructor
